import { isEmpty, isNumber } from 'lodash';

const FILTER_NON_POSITIVE = ({ _data: data }: { _data: (number | null | undefined)[] }) => {
  if (!Array.isArray(data)) {
    return [0];
  }

  const result = data.filter(value => isNumber(value) && value > 0);

  return isEmpty(result) ? [0] : result;
};

const FILTER_ZEROS = ({ _data: data }: { _data: (number | null | undefined)[] }) => {
  if (!Array.isArray(data)) {
    return [0];
  }
  const result = data.filter(value => isNumber(value) && value !== 0);

  return isEmpty(result) ? [0] : result;
};

export const FILTER_ZEROS_AS_OBJECT = (params: { _data: (number | null | undefined)[] }) => {
  const filteredValue = FILTER_ZEROS(params);
  return { _data: filteredValue };
};

export const FILTER_NON_POSITIVE_AS_OBJECT = (params: { _data: (number | null | undefined)[] }) => {
  const filteredValue = FILTER_NON_POSITIVE(params);
  return { _data: filteredValue };
};

// New function that filters zeros and converts currency in one step
export const FILTER_ZEROS_AND_CONVERT_CURRENCY = (params: { _data: (number | null | undefined)[] }, exchangeRate: number) => {
  const filteredValue = FILTER_ZEROS(params);
  // Convert each value by the exchange rate
  const convertedValue = filteredValue.map(value => value * exchangeRate);
  return { _data: convertedValue };
};

export default FILTER_NON_POSITIVE;
